import React, { useMemo } from "react";
import { useParams } from "react-router-dom";
import SettingsMenu from "./SettingsMenu";
import * as Views from "./Views";

export default function Settings(): React.ReactElement {
  const { view } = useParams<{ view?: string }>();

  // Memoize items array to maintain referential equality across re-renders
  const items = useMemo(() => [
    { name: "Two-Factor Authentication", component: Views.TwoFactorAuth, slug: "two-factor-auth" },
    { name: "Single Sign-On", component: Views.SingleSignOn, slug: "single-sign-on" },
    { name: "Change Password", component: Views.ChangePassword, slug: "change-password" },
  ], []);
   
  const initialView = useMemo(() => {
    if (!view) {
      return undefined;
    }
    const matchedItem = items.find(item => item.slug === view);
    return matchedItem?.name;
  }, [view, items]);

  return (
    <div className="w-full px-6 lg:px-10 py-8 lg:py-10 bg-white">
      <h1 className="text-left text-primary font-medium text-xl lg:text-3xl mb-6 font-decimal [transform:scaleY(1.0)] origin-bottom">
        Settings
      </h1>

      <SettingsMenu items={items} children={null} initialView={initialView} />
    </div>
  );
}
